import React from 'react'
import { Link } from 'react-router-dom'

import { TrendingUp, AddCircleOutline, ThumbDownOutlined } from '@material-ui/icons'

import './Index.css'

const Index = ({ user }) => {
    const counter = user?.workPlace

    return (
        <div className="index">
             <h2 className="mb-40 py-20 font-subhead">{user?.name}</h2>
             <div className="index__cards">
                <div className="index__projects py-20 px-40">
                    <p className="font-big font-bold">Projects</p>
                    <div className="d-flex flex-wrap">
                        <Link to="/translator/new" className="index__translator__card d-flex flex-column box-shadow-lg p-20 my-20 mr-20 rounded">
                            <div className="d-flex align-center">
                                <AddCircleOutline className="icon-orange" fontSize="small" />
                                <span className="pl-10 font-bold font-sm">New Projects</span>
                            </div>
                            <span style={{background: 'rgb(223, 255, 223)', color: 'green'}} className="font-bolder ml-auto text-right px-20 mt-5 curved-20">{!counter ? 0 : counter.new_projects ? counter.new_projects.length : 0}</span>
                        </Link>
                        <Link to="/translator/ongoing" className="index__translator__card d-flex flex-column box-shadow-lg p-20 my-20 mr-20 rounded">
                            <div className="d-flex align-center">
                                <TrendingUp className="icon-orange" fontSize="small" />
                                <span className="pl-10 font-bold font-sm">Ongoing Projects</span>
                            </div>
                            <span style={{background: 'rgb(255, 236, 200)', color: 'orange'}} className="font-bolder ml-auto text-right px-20 mt-5 curved-20">{!counter ? 0 : counter.ongoing_projects ? counter.ongoing_projects.length : 0}</span>
                        </Link>
                        <Link to="/translator/declined" className="index__translator__card d-flex flex-column box-shadow-lg p-20 my-20 mr-20 rounded">
                            <div className="d-flex align-center">
                                <ThumbDownOutlined className="icon-orange" fontSize="small" />
                                <span className="pl-10 font-bold font-sm">Declined Projects</span>
                            </div>
                            <span style={{background: 'rgb(255, 205, 220)', color: 'red'}} className="font-bolder ml-auto text-right px-20 mt-5 curved-20">{!counter ? 0 : counter.declined_projects ? counter.declined_projects.length : 0}</span>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Index
